import React, { useState } from 'react';
import { Row, Col, Card } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import PropTypes from 'prop-types';
import { SpinnerSize } from '@fluentui/react';
import Loading from '../../components/Templates/Site/Loading';
import { __MessageTypes, enum_OBLIGATION_FORM_VIEW } from '../../common/Dictionaries';
import { showMessage } from '../../common/Helpers';


const SidePanelView = (props) => {
    const { t } = useTranslation();
   
    let {
        inputParam_IsPanelOpen = null,
        inputParam_SetterIsPanelOpen = null,
        inputParam_PreviewBase64Document = null,
    } = props;

   
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
  


    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
        showMessage(setMessageConfig, false, null, null)
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };   

    const onClosePanel = () => {
        onDismissPanel();
    };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12}>
                        <DefaultButton className='mx-1' onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                    </Col>
                </Row>
    };

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-preview') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.extraLarge }
                type={ PanelType.extraLarge }
            >
                <Row className="h-100">
                    <Col className="d-flex align-items-center justify-content-center">
                        {
                            inputParam_PreviewBase64Document &&
                            <iframe
                                title='faq'
                                src={URL.createObjectURL(inputParam_PreviewBase64Document)}
                                width="100%"
                                height="100%"
                                style={{ border: 0 }}
                            />
                        }
                        {
                            !inputParam_PreviewBase64Document &&
                            <Loading
                                inputParam_ShowLoading={true}
                                inputParam_ShowText={false}
                                inputParam_Width={'35px'}
                                inputParam_Height={'35px'}
                                inputParam_Left={""}
                                inputParam_Style={{marginTop: 0}}
                                inputParam_ColClassName={"me-2"}
                                inputParam_MarginLeft={"auto"}
                                inputParam_SpinnerSize={SpinnerSize.medium} />
                        }

                    </Col>
                </Row>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

SidePanelView.propTypes = {
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
};

export default SidePanelView;